import { render } from "./Importances.vue?vue&type=template&id=62bc4216&scoped=true"
import script from "./Importances.vue?vue&type=script&lang=js"
export * from "./Importances.vue?vue&type=script&lang=js"

import "./Importances.vue?vue&type=style&index=0&id=62bc4216&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bc4216"]])

export default __exports__